import styled, { keyframes } from "styled-components";
import { useEffect, useRef } from "react";
import { colors } from "@/constants";

declare global {
  interface Window {
    BarcodeDetector: any;
  }
}

const animationVideo = keyframes`
  from {
    top: -100vh;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
`;

const animation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ContetVideo = styled.div`
  background-color: ${colors.shadown7};
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 99000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${animation} 0.5s ease;
`

const Video = styled.video`
  width: 75%;
  border-radius: 10px;
  position: absolute;
  top: 30px;
  height: 130px;
  left: 50%;
  transform: translateX(-50%);
  object-fit: cover;
  animation: ${animationVideo} 0.4s ease;
`

interface Props {
  closeCamera: () => void;
  handleClick?: () => void;
  handleFilter: (value: string) => void;
}

const VideoScanner = ({ handleFilter, closeCamera }: Props) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const isScanning = useRef<boolean>(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      closeCamera();
    }, 9000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const startScanner = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().then(() => {
            isScanning.current = true;
          })
            .catch(err => {
              console.error("Erro ao iniciar vídeo:", err);
            });;
        }

        const barcodeDetector = new window.BarcodeDetector({
          formats: ["ean_13", "code_128", "qr_code"],
        });

        const scanBarcode = async () => {
          if (videoRef.current && isScanning.current) {
            try {
              const barcodes = await barcodeDetector?.detect(videoRef.current);
              if (barcodes?.length > 0) {
                handleFilter(barcodes[0].rawValue);
                closeCamera();
              }
            } catch (error) {
              console.log("Erro ao detectar código:", error);
            }
          }
          requestAnimationFrame(scanBarcode);
        };

        scanBarcode();
      } catch (error) {
        console.log("Erro ao acessar a câmera:", error);
      }
    };

    startScanner();

    return () => {
      if (videoRef.current?.srcObject) {
        const tracks = (videoRef.current.srcObject as MediaStream).getTracks();
        tracks.forEach((track) => track.stop());
      }
    };
  }, []);

  return (
    <>
      <ContetVideo onClick={closeCamera} />
      <Video ref={videoRef} />
    </>
  );
};

export default VideoScanner;
